import $ from './jquery-3.2.1.min';
import publicFunctions from './public-functions'
import variables from './variables';

const conditions = {
	runHemA: runHemA,
	runHemB: runHemB,
	runvWD: runvWD
}

export default conditions;

// This function sets and run the default animation for "Hemophilia A" and show the treatments buttons for "Hemophilia A" and hide the other ones
function runHemA(){	
	publicFunctions.showAllGears();
	publicFunctions.resetTimelines();
	publicFunctions.resetConditionState();
	publicFunctions.defaultScaleDown();
	
	//Only get in if the button of the current timeline hasn't be clicked yet
	if(variables.counters.hemACounter <= 0){
		//sets animation gears and factors for condition and inhibitor actions
		variables.hemATimeline.to(belt_full, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
		variables.hemATimeline.to(belt_broken, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
		variables.hemATimeline.to(factor_08_activated, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
		variables.hemATimeline.to(factor_12_div, .5, {scale: 1});
		variables.hemATimeline.to(factor_12, 3.5, {rotation: -1260, ease: Power0.easeNone, delay: .5}, 0);
		variables.hemATimeline.to(grey_gear_01, 3.5, {rotation: 1260, ease: Power0.easeNone, delay: .5}, 0);
		variables.hemATimeline.to(factor_11_div, .5, {scale: 1, delay: 1}, 0);
		variables.hemATimeline.to(factor_11, 2.5, {rotation: -900, ease: Power0.easeNone, delay: 1.5}, 0);
		variables.hemATimeline.to(small_gear_01, 2.5, {rotation: 900, ease: Power0.easeNone, delay: 1.5}, 0);
		variables.hemATimeline.to(factor_09_div, .5, {scale: 1, delay: 2}, 0);
		variables.hemATimeline.to(factor_09, 1.5, {rotation: -540, ease: Power0.easeNone, delay: 2.5}, 0);
		variables.hemATimeline.to(grey_gear_02, 1.5, {rotation: 540, ease: Power0.easeNone, delay: 2.5}, 0);
		variables.hemATimeline.to(factor_08_div, .5, {scale: 1, delay: 3}, 0);
		variables.hemATimeline.to(factor_08, .5, {fill: "#cbf3ee", delay: 3.5}, 0);
		variables.hemATimeline.to(factor_CLOT, .5, {fill: "#cbf3ee", delay: 3.5}, 0);
		variables.hemATimeline.to(belt_full, .5, {autoAlpha: 0, display: 'none', delay: 3.5}, 0);
		variables.hemATimeline.to(belt_broken, .5, {autoAlpha: 1, display: 'block', delay: 3.5}, 0);
		variables.hemATimeline.to([factor_12, factor_11, factor_09], 10, {rotation: -3600, ease: Power0.easeNone, delay: 4, repeat:-1}, 0);
		variables.hemATimeline.to([grey_gear_01, grey_gear_02, small_gear_01], 10, {rotation: 3600, ease: Power0.easeNone, delay: 4, repeat:-1}, 0);
		// Increase the counter
		variables.counters.hemACounter++;
	}
	
	// Start the animation setted before
	variables.hemATimeline.play();

}

// This function sets and run the default animation for "Hemophilia B" and show the treatments buttons for "Hemophilia B" and hide the other ones
function runHemB(){
	publicFunctions.showAllGears();
	publicFunctions.resetTimelines();
	publicFunctions.resetConditionState();
	publicFunctions.defaultScaleDown();

	//Only get in if the button of the current timeline hasn't be clicked yet
	if(variables.counters.hemBCounter <= 0){
		//sets animation gears and factors for condition and inhibitor actions
		variables.hemBTimeline.to(belt_full, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
		variables.hemBTimeline.to(belt_broken, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
		variables.hemBTimeline.to(factor_08_activated, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
		variables.hemBTimeline.to(factor_12_div, .5, {scale: 1});
		variables.hemBTimeline.to(factor_12, 3.5, {rotation: -1260, ease: Power0.easeNone, delay: .5}, 0);
		variables.hemBTimeline.to(grey_gear_01, 3.5, {rotation: 1260, ease: Power0.easeNone, delay: .5}, 0);
		variables.hemBTimeline.to(factor_11_div, .5, {scale: 1, delay: 1}, 0);
		variables.hemBTimeline.to(factor_11, 2.5, {rotation: -900, ease: Power0.easeNone, delay: 1.5}, 0);
		variables.hemBTimeline.to(small_gear_01, 2.5, {rotation: 900, ease: Power0.easeNone, delay: 1.5}, 0);
		variables.hemBTimeline.to(factor_09_div, .5, {scale: 1, delay: 2}, 0);
		variables.hemBTimeline.to(factor_09, .5, {fill: "#cbf3ee", delay: 2.5}, 0);
		variables.hemBTimeline.to(factor_CLOT, .5, {fill: "#cbf3ee", delay: 2.5}, 0);
		variables.hemBTimeline.to(belt_full, .5, {autoAlpha: 0, display: 'none', delay: 2.5}, 0);
		variables.hemBTimeline.to(belt_broken, .5, {autoAlpha: 1, display: 'block', delay: 2.5}, 0);
		variables.hemBTimeline.to([factor_12, factor_11], 10, {rotation: -3600, ease: Power0.easeNone, delay: 4, repeat:-1}, 0);
		variables.hemBTimeline.to([grey_gear_01, small_gear_01], 10, {rotation: 3600, ease: Power0.easeNone, delay: 4, repeat:-1}, 0);
		// Increase the counter
		variables.counters.hemBCounter++;
	}
	//TweenLite.to(variables.hemA_Low_image, 1, {autoAlpha: 1, display: 'block'});
	// Start the animation setted before
	variables.hemBTimeline.play();
}

// This function sets and run the default animation for "von Willebrand" and show the treatments buttons for "von Willebrand" and hide the other ones
function runvWD(){
	publicFunctions.showAllGears();
	publicFunctions.resetTimelines();
	publicFunctions.resetConditionState();
	publicFunctions.defaultScaleDown();

	//Only get in if the button of the current timeline hasn't be clicked yet
	if(variables.counters.vWCounter <= 0){
		//sets animation gears and factors for condition and inhibitor actions
		variables.vWTimeline.to(belt_full, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
		variables.vWTimeline.to(belt_broken, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
		variables.vWTimeline.to(factor_08_activated, 0, {autoAlpha: 1, display: 'block',stroke: "#ffffff", delay:0}, 0);
		variables.vWTimeline.to(factor_12_div, .5, {scale: 1});
		variables.vWTimeline.to(factor_12, 3.5, {rotation: -1260, ease: Power0.easeNone, delay: .5}, 0);
		variables.vWTimeline.to(grey_gear_01, 3.5, {rotation: 1260, ease: Power0.easeNone, delay: .5}, 0);
		variables.vWTimeline.to(factor_11_div, .5, {scale: 1, delay: 1}, 0);
		variables.vWTimeline.to(factor_11, 2.5, {rotation: -900, ease: Power0.easeNone, delay: 1.5}, 0);
		variables.vWTimeline.to(small_gear_01, 2.5, {rotation: 900, ease: Power0.easeNone, delay: 1.5}, 0);
		variables.vWTimeline.to(factor_09_div, .5, {scale: 1, delay: 2}, 0);
		variables.vWTimeline.to(factor_09, 1.5, {rotation: -540, ease: Power0.easeNone, delay: 2.5}, 0);
		variables.vWTimeline.to(grey_gear_02, 1.5, {rotation: 540, ease: Power0.easeNone, delay: 2.5}, 0);
		variables.vWTimeline.to(factor_08_div, .5, {scale: 1, delay: 3}, 0);
		variables.vWTimeline.to(factor_vW_div, .5, {scale: 1, delay: 3.5}, 0);
		variables.vWTimeline.to(factor_vW, .5, {fill: "#cbf3ee", delay: 4}, 0);
		variables.vWTimeline.to(factor_CLOT, .5, {fill: "#cbf3ee", delay: 4}, 0);
		variables.vWTimeline.to(belt_full, .5, {autoAlpha: 0, display: 'none', delay: 4}, 0);
		variables.vWTimeline.to(belt_broken, .5, {autoAlpha: 1, display: 'block', delay: 4}, 0);
		variables.vWTimeline.to([factor_12, factor_11, factor_09], 10, {rotation: -3600, ease: Power0.easeNone, delay: 4, repeat:-1}, 0);
		variables.vWTimeline.to([grey_gear_01, small_gear_01, grey_gear_02], 10, {rotation: 3600, ease: Power0.easeNone, delay: 4, repeat:-1}, 0);
		// Increase the hemACounter
		variables.counters.vWCounter++;
	}
	// Start the animation setted before
	variables.vWTimeline.play();
}



// WEBPACK FOOTER //
// ./src/js/conditions.js